import React from 'react';
import { TextField } from 'material-ui';
import moment from 'moment';
import parseFormat from 'moment-parseformat';
import PropTypes from 'prop-types';

import OurismanTravelTheme from '../ourismanTravelTheme';

export default class DateField extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    parseDate: PropTypes.bool,
    className: PropTypes.string,
  }

  static defaultProps = {
    value: '',
    parseDate: true,
    className: '',
  }

  constructor(props) {
    super(props);
    this.state = {
      input: this.props.value,
      parsedValue: '',
      errorText: '',
    };
  }

  onChange = (e) => {
    const { onChange: passedOnChange, parseDate } = this.props;
    const { target: { value } } = e;

    if (parseDate) {
      const nextState = this.processValue(value);
      this.setState(nextState);

      const { input, parsedValue } = nextState;

      const newValue = parsedValue && parsedValue.isValid() ?
        parsedValue.format('YYYY-MM-DD') : input;

      passedOnChange({ target: { value: newValue } });
    } else {
      this.setState({
        input: value,
        parsedValue: value,
        errorText: null,
      });
      passedOnChange(e);
    }
  }

  processValue = (value) => {
    const format = 'dddd, MMMM Do YYYY';

    const enteredFormat = parseFormat(value);
    const parsedValue = moment(value, enteredFormat);
    if (parsedValue < moment() && enteredFormat.search('Y') < 0) {
      parsedValue.add(1, 'years');
    }

    return {
      input: value,
      parsedValue: parsedValue && parsedValue.isValid() ? parsedValue : null,
      errorText: parsedValue && parsedValue.isValid() ?
        parsedValue.format(format) : "can't interpret date",
    };
  }

  render() {
    const { input, errorText, parsedValue } = this.state;
    const textFieldProps = { ...this.props };
    delete textFieldProps.parseDate;
    delete textFieldProps.onChange;
    delete textFieldProps.value;
    delete textFieldProps.className;

    const errorStyle = {
      color: parsedValue && moment(parsedValue).isValid() ?
        OurismanTravelTheme.palette.primary1Color :
        OurismanTravelTheme.palette.accent2Color,
    };

    return (<TextField
      {...textFieldProps}
      className={this.props.className}
      value={input}
      onChange={this.onChange}
      errorText={errorText}
      errorStyle={errorStyle}
      floatingLabelFocusStyle={errorStyle}
    />);
  }
}



// WEBPACK FOOTER //
// /src/components/DateFieldComponent.js